import dayjs from 'dayjs';

const TOKEN_KEY = 'user-token';
const EXPIRATION_KEY = 'token-expiration-date';

/**
 * Días que el token se considera válido en el navegador.
 *
 * El token de DRF no caduca en servidor, así que esto es únicamente el
 * temporizador de cierre de sesión del cliente. Antes se calculaba con
 * `dayjs().set('day', 10)`, que fija el día *de la semana* y hacía que la
 * duración variase entre ~4 y ~10 días según el día en que se iniciase sesión.
 */
const TOKEN_LIFETIME_DAYS = 10;

/**
 * Punto único de acceso al token de autenticación.
 *
 * No importa nada del store ni del cliente HTTP a propósito: lo usan tanto el
 * interceptor de peticiones como el propio store, y así no se crean ciclos.
 */
const TokenService = {

    /** Devuelve el token vigente, o null si no hay o ya caducó. */
    get(): string | null {
        const token = localStorage.getItem(TOKEN_KEY);
        if (!token) {
            return null;
        }

        const expiration = localStorage.getItem(EXPIRATION_KEY);

        // Sesiones abiertas antes de que existiera la fecha de caducidad: no
        // cerramos la sesión por sorpresa, se le asigna una y sigue adelante.
        if (!expiration) {
            TokenService.touch();
            return token;
        }

        if (dayjs().isAfter(dayjs(expiration))) {
            TokenService.clear();
            return null;
        }

        return token;
    },

    set(token: string): void {
        localStorage.setItem(TOKEN_KEY, token);
        TokenService.touch();
    },

    clear(): void {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(EXPIRATION_KEY);
    },

    touch(): void {
        localStorage.setItem(
            EXPIRATION_KEY,
            dayjs().add(TOKEN_LIFETIME_DAYS, 'day').toString(),
        );
    },
};

export default TokenService;
